import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import dicts from './modules/dicts'
import guestVisits from './modules/guest-visits'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  modules: {
    dicts,
    guestVisits
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js